class NoteMatcherHelper {
  constructor(tolerance_range, rightCallback, wrongCallback) {
    this.advance_tolerance = tolerance_range;
    this.late_tolerance = tolerance_range;
    this.startTime = null;
    this.listenedNotes = [];
    this.playedNotes = [];
    this.lastListenedIndex = 0;
    this.lastPlayedIndex = 0;
    this.timer = null;
    this.onNotesChanged = null;
    // algorithm options:

    // ignora le note sotto una certa durata (occhio che alcuni strumenti sono intrinsecamente "corti"
    this.skipShortNotes = false;
    // fa il check fino a fine della nota (meno tolerance)
    this.extended = false;
    // se trova una nota sbagliata, si ferma e quella nota è sbagliata.
    this.pedantic = false;
    // abilita/disabilita il controllo delle ottave (alcuni strumenti saranno trasposti)
    this.checkOctaves = false;

    this.defaultRightNoteCallback = rightCallback;
    this.defaultWrongNoteCallback = wrongCallback;
  }

  // questa arriva alla fine della nota, prima non abbiamo la durata.
  onListenedNote(note) {
    this.listenedNotes.push({
      note,
      matches: false
    });
    if (this.onNotesChanged) this.onNotesChanged();
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => this.matcher(), 200);
  }

  // questa viene chiamata all'inizio della nota.
  onPlayedNote(note, path) {
    if (!note) return;
    this.playedNotes.push({
      note,
      path
    });
    if (this.onNotesChanged) this.onNotesChanged();
  }

  compare_notes = (first, second) => {
    if (this.checkOctaves) return first.equals(second);
    else{
      return first.pitch.toLowerCase() === second.pitch.toLowerCase() && first.accidental === second.accidental;
    } 
  };

  matcher() {
    this.matcherLogic(this.defaultRightNoteCallback, this.defaultWrongNoteCallback);
  }

  matcherLogic(rightNoteCallback, wrongNoteCallback, debug = false) {
    console.log('MATCHER: note registrate %s, suonate %s', this.listenedNotes.length, this.playedNotes.length);
    let lastPlayedIndex = 0;
    for (let i = this.lastPlayedIndex; i < this.playedNotes.length; i++) {
      lastPlayedIndex = i;
      const { note: playedNote, path } = this.playedNotes[i];
      if(debug)
        console.log('MATCHING NOTE: ', playedNote);
      let res;
      let durationRes;
      let lastListenedIndex = 0;
      for (let x = this.lastListenedIndex; x < this.listenedNotes.length; x++) {
        lastListenedIndex = x;
        const { note: listenedNote } = this.listenedNotes[x];

        // SE VOGLIAMO RIMUOVERE LE NOTE TROPPO CORTE:
        if (this.skipShortNotes) {
          if (listenedNote.duration < 50) {
            this.listenedNotes[x].skipped = true;
            continue;
          }
        }

        // LOGICA DI DURATA:
        if (listenedNote < playedNote.duration * 1.2 || listenedNote.duration > playedNote.duration * 0.8) {
          durationRes = true;
        }

        if (
          listenedNote.timestamp > playedNote.timestamp - this.advance_tolerance &&
          listenedNote.timestamp < playedNote.timestamp + this.late_tolerance
        ) {
          this.playedNotes[i].listenedFound = true;
          this.listenedNotes[x].checked = true;
          if (this.compare_notes(playedNote, listenedNote)) {
            res = true;
            this.listenedNotes[x].matches = true;
            this.playedNotes[i].matches = true;
            // assumiamo che la nota precedente sia della lunghezza giusta se è giusta ed è giusta la successiva.
            if (i > 0 && this.playedNotes[i - 1].matches) {
              this.playedNotes[i - 1].rightLength = true;
            }
            if (!this.pedantic) break;
          } else {
            if (debug)
              console.log(
                'LISTENED NOTE NOT MATCH %s (%s) vs %s (%s)',
                listenedNote.pitch,
                listenedNote.accidental,
                playedNote.pitch,
                playedNote.accidental
              );
          }
          if (this.pedantic) break;
        } else if (
          this.extended &&
          listenedNote.timestamp >= playedNote.timestamp + this.late_tolerance &&
          listenedNote.timestamp <= playedNote.timestamp + playedNote.duration - this.advance_tolerance
        ) {
          this.listenedNotes[x].checked_extended = true;
          if (this.compare_notes(playedNote, listenedNote)) {
            res = true;
            this.listenedNotes[x].matches_extended = true;
            this.playedNotes[i].matches_extended = true;
            break;
          } else {
            if (debug)
              console.log(
                'LISTENED NOTE NOT MATCH EXTENDED %s (%s) vs %s (%s)',
                listenedNote.pitch,
                listenedNote.accidental,
                playedNote.pitch,
                playedNote.accidental
              );
          }
          //} else if (listenedNote.timestamp > playedNote.timestamp + this.tolerance_range) {
        } else if (listenedNote.timestamp > playedNote.timestamp + playedNote.duration - this.advance_tolerance) {
          if (lastListenedIndex !== 0) lastListenedIndex--; // Se la nota registrata è successiva a quella suonata torno indietro
          break;
        } else {
          //qui dentro avrei le note che sono suonate *prima* di (playednote - tolerance)
          if (!this.listenedNotes[x].checked && !this.listenedNotes[x].checked_extended)
            this.listenedNotes[x].skipped = true;
        }
      }
      this.lastListenedIndex = lastListenedIndex;
      if (res) {
        if (rightNoteCallback) rightNoteCallback(path, durationRes);
      } else {
        if (wrongNoteCallback) wrongNoteCallback(path);
      }
    }
    this.lastPlayedIndex = lastPlayedIndex;
  }

  reset() {
    console.log('MATCHER: reset');
    this.listenedNotes = [];
    this.playedNotes = [];
    this.startTime = null;
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  //$r.noteMatcherHelper.playedNotes = JSON.parse(localStorage.getItem('playedNotes'));
}

export default NoteMatcherHelper;
